const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/devices/types/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/devices/types/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { DeviceTypesPendingState } from '@/features/device-types/components/DeviceTypesPendingState';
import { deviceTypesQuery } from '@/features/device-types/services/deviceTypeQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/devices/types/')({
  loader: ({
    context
  }) => context.queryClient.ensureQueryData(deviceTypesQuery()),
  pendingComponent: DeviceTypesPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});